<div class="relative min-h-screen bg-gray-50 dark:bg-gray-900" [ngClass]="{'rtl': language === 'ar', 'ltr': language === 'en'}">
  <!-- Decorative Background Elements -->
  <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-30">
    <div class="absolute -left-40 -top-40 w-80 h-80 bg-gradient-to-tr from-arabic-green to-arabic-black blur-3xl transform-gpu gradient-animation"></div>
    <div class="absolute right-0 bottom-0 w-80 h-80 bg-gradient-to-tr from-arabic-black to-arabic-green blur-3xl transform-gpu gradient-animation"></div>
  </div>

  <!-- Main Content Container -->
  <div class="container mx-auto px-4 py-12 relative z-10">
    <!-- Article Card -->
    <div class="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">

      <!-- Header Image -->
      <div class="h-64 bg-gradient-to-r from-arabic-green-dark to-arabic-green relative">
        <div class="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
          <h1 class="text-4xl md:text-5xl font-bold text-white text-center px-6">{{ language === 'ar' ? title : titleEn }}</h1>
        </div>
      </div>

      <!-- Article Content -->
      <div class="p-6 md:p-8" [ngClass]="{'text-right': language === 'ar', 'text-left': language === 'en'}">
        <!-- Date -->
        <div class="mb-6 text-gray-500 dark:text-gray-400" [ngClass]="{'flex justify-end': language === 'ar', 'flex justify-start': language === 'en'}">
          <div *ngIf="language === 'en'" class="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span>{{ publishDate | date:'longDate' }}</span>
          </div>
          <div *ngIf="language === 'ar'" class="flex items-center">
            <span>{{ publishDate | date:'longDate':'':'ar' }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
        </div>

        <!-- Article Paragraphs - Arabic -->
        <div *ngIf="language === 'ar'" class="space-y-6 text-lg leading-relaxed text-gray-800 dark:text-gray-200">
          <p>
            في السنوات الأخيرة، شهدت المقبرة تحولات ملحوظة تعكس التقدم في كيفية التعامل مع الموتى واحتياجات أسرهم. حيث كانت المقابر تُترك دون تخطيط، مما جعلها تبدو كأماكن مهجورة. كانت الزيارات إلى المقابر تُعتبر تجربة حزينة وغير مريحة، حيث كانت الطرق غير معبدة والزهور نادرة.
          </p>

          <div class="py-2 px-4 bg-arabic-green/5 border-r-4 border-arabic-green rounded">
            <p class="text-arabic-green-dark dark:text-arabic-green">
              ومع ذلك، بدأت النقلة في المقبرة عندما تم إدخال مفهوم التخطيط الحضري والاهتمام بالمساحات الخضراء. تم تطوير المقبرة لتصبح مكانًا يبعث على السكينة والهدوء.
            </p>
          </div>

          <p>
            تم إنشاء مسارات مرصوفة وحدائق مزهرة، مما جعل الزيارات أكثر راحة. بالإضافة إلى ذلك، تم توفير خدمات جديدة مثل أماكن للجلوس ومرافق للزوار وتقديم بعض الخدمات التي تساعد الزوار مثل توفير الماء البارد للشرب وبعض الاحتياجات الأخرى ، مما ساهم في تحسين تجربة العائلات.
          </p>

          <!-- Features Grid -->
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 my-8">
            <div class="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600 text-center hover:bg-arabic-green/5 transition-colors">
              <div class="w-12 h-12 mx-auto mb-3 bg-arabic-green/10 rounded-full flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-arabic-green" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 class="text-arabic-green-dark dark:text-arabic-green font-bold">مسارات مرصوفة</h3>
              <p class="text-sm mt-2 text-gray-600 dark:text-gray-300">تسهيل حركة الزوار وتنقلهم في المقبرة</p>
            </div>

            <div class="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600 text-center hover:bg-arabic-green/5 transition-colors">
              <div class="w-12 h-12 mx-auto mb-3 bg-arabic-green/10 rounded-full flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-arabic-green" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </div>
              <h3 class="text-arabic-green-dark dark:text-arabic-green font-bold">حدائق مزهرة</h3>
              <p class="text-sm mt-2 text-gray-600 dark:text-gray-300">إضفاء جو من الراحة والجمال على المكان</p>
            </div>

            <div class="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600 text-center hover:bg-arabic-green/5 transition-colors">
              <div class="w-12 h-12 mx-auto mb-3 bg-arabic-green/10 rounded-full flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-arabic-green" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 class="text-arabic-green-dark dark:text-arabic-green font-bold">مرافق للزوار</h3>
              <p class="text-sm mt-2 text-gray-600 dark:text-gray-300">خدمات متنوعة تلبي احتياجات العائلات</p>
            </div>
          </div>

          <p>
           اليوم، أصبحت المقبرة ليست مجرد مكان للدفن، بل هي مساحة تذكارية تعكس الحب والاحترام للذين فقدناهم. يتم تنظيم فعاليات تذكارية وأيام خاصة لزيارة الراحلين، مما يعزز من الروابط المجتمعية ويشجع على التذكر الإيجابي.
          </p>

          <p class="text-center italic text-arabic-green-dark dark:text-arabic-green text-lg">
            هذه النقلة في المقبرة تعكس التقدم في كيفية تعبيرنا عن الحزن والاحتفاء بالذكريات، مما يجعلها مكانًا يبعث على الأمل والسلام ببركات الصلاة على محمد وال محمد
          </p>
        </div>

        <!-- Article Paragraphs - English -->
        <div *ngIf="language === 'en'" class="space-y-6 text-lg leading-relaxed text-gray-800 dark:text-gray-200">
          <p>
            In recent years, the cemetery has undergone notable transformations reflecting progress in how we handle the deceased and their families' needs. Previously, cemeteries were left unplanned, appearing as abandoned places. Visits to cemeteries were considered sad and uncomfortable experiences, with unpaved roads and scarce flowers.
          </p>

          <div class="py-2 px-4 bg-arabic-green/5 border-l-4 border-arabic-green rounded">
            <p class="text-arabic-green-dark dark:text-arabic-green">
              However, the transformation began when concepts of urban planning and attention to green spaces were introduced. The cemetery was developed to become a place that evokes tranquility and peace.
            </p>
          </div>

          <p>
            Paved pathways and flowering gardens were created, making visits more comfortable. Additionally, new services were provided such as seating areas and visitor facilities, offering amenities like cold drinking water and other necessities, which helped improve the family experience.
          </p>

          <!-- Features Grid -->
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 my-8">
            <div class="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600 text-center hover:bg-arabic-green/5 transition-colors">
              <div class="w-12 h-12 mx-auto mb-3 bg-arabic-green/10 rounded-full flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-arabic-green" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 class="text-arabic-green-dark dark:text-arabic-green font-bold">Paved Pathways</h3>
              <p class="text-sm mt-2 text-gray-600 dark:text-gray-300">Facilitating visitor movement and navigation through the cemetery</p>
            </div>

            <div class="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600 text-center hover:bg-arabic-green/5 transition-colors">
              <div class="w-12 h-12 mx-auto mb-3 bg-arabic-green/10 rounded-full flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-arabic-green" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </div>
              <h3 class="text-arabic-green-dark dark:text-arabic-green font-bold">Flowering Gardens</h3>
              <p class="text-sm mt-2 text-gray-600 dark:text-gray-300">Creating an atmosphere of comfort and beauty in the space</p>
            </div>

            <div class="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600 text-center hover:bg-arabic-green/5 transition-colors">
              <div class="w-12 h-12 mx-auto mb-3 bg-arabic-green/10 rounded-full flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-arabic-green" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 class="text-arabic-green-dark dark:text-arabic-green font-bold">Visitor Facilities</h3>
              <p class="text-sm mt-2 text-gray-600 dark:text-gray-300">Various services meeting family needs</p>
            </div>
          </div>

          <p>
            Today, the cemetery is not just a burial place, but a memorial space reflecting love and respect for those we have lost. Memorial events and special days for visiting the deceased are organized, strengthening community bonds and encouraging positive remembrance.
          </p>

          <p class="text-center italic text-arabic-green-dark dark:text-arabic-green text-lg">
            This transformation in the cemetery reflects progress in how we express grief and celebrate memories, making it a place that brings hope and peace with blessings of prayers upon Muhammad and his family.
          </p>
        </div>

        <!-- Divider with decorative element -->
        <!-- <div class="my-8 flex items-center justify-center">
          <div class="w-1/3 h-px bg-gray-300 dark:bg-gray-600"></div>
          <div class="mx-4 text-arabic-green">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
            </svg>
          </div>
          <div class="w-1/3 h-px bg-gray-300 dark:bg-gray-600"></div>
        </div> -->

        <!-- Call to action -->
        <!-- <div class="mt-8 text-center">
          <button class="bg-arabic-green hover:bg-arabic-green-dark text-white font-bold py-3 px-6 rounded-full transition-colors shadow-md">
            {{ language === 'ar' ? 'زيارة المقبرة الآن' : 'Visit the Cemetery Now' }}
          </button>
        </div> -->
      </div>
    </div>

    <!-- Footer
    <div class="mt-12 text-center text-gray-500 dark:text-gray-400">
      <p>{{ language === 'ar' ? '© جميع الحقوق محفوظة -' : '© All Rights Reserved -' }} {{ publishDate | date:'yyyy' }}</p>
    </div> -->
  </div>
</div>
